// 数组转换成树结构
// 使用 parent 字段作为 key
export function arrToTree(array) {
  const tree = {};

  array.forEach(item => {
    tree[item.key] = item;
  });

  for (let key in tree) {
    const child = tree[key];
    if (child.parent) {
      let parent = tree[child.parent];
      if (!parent) {
        tree[child.parent] = [];
      }
      tree[child.parent].push(child);
      delete tree[key];
    }
  }

  return tree;
}

// 获取Y轴最大值
export function getYAxisMax(num) {
  const int = parseInt(num);
  const len = int.toString().length;
  const times = parseInt(1 + new Array(len).join('0'));
  return Math.ceil(int / times) * times;
}
